import { AsyncDropdown } from "src/app/models/async-dropdown";

export class Budget {
    identifier: string;
    code: string;
    jiraProjectLink: string;
    description: string;
    jobCode: string;
    name: string;
    budgetProducts: Array<any>;
    project: any;
    tags: any;
    type: AsyncDropdown;
    department: AsyncDropdown;
    jiraProjectActions: any;
  }
  